var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 p-st",class:{
    'bg-light': !_vm.nightMode,
    'bg-dark2': _vm.nightMode,
    'text-light': _vm.nightMode,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }